<template lang="html">

  <footer class="footer row-between">

    <img src="/static/img/logo-footer.png" width="215" alt="Logo footer UVA">

    <nav>
      <a href="/politica-de-cookies" target="_blank">Política de Cookies</a>
      <a href="/aviso-legal" target="_blank">Aviso legal</a>
      <a href="/politica-de-privacidad" target="_blank">Política de privacidad</a>
      <div class="box-sepe">
        <img src="/static/img/logo-sepe.jpg" alt="Logo Sepe">
        <strong>Agencia de Colocación Nº 0800000285</strong>
      </div>
    </nav>

  </footer>

</template>

<script lang="js">
  export default {
    name: 'app-footer',
  }
</script>

<style scoped>
  .footer {}
</style>


// WEBPACK FOOTER //
// src/components/parts/footer.vue